<template>
<div>
  <div class="container-fluid">
    <div class="row mt17">
      <div class="col-sm-12">
        <data-table
          :title="title"
          :tableHeaders="tableHeaders"
          :radioFilter="radioFilter"
          :onAction="onAction"
          :rowActions="rowActions"
          :rowBackground="rowBackground"
          :getData="getPayments"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import DataTable from '@/components/shared/dataTable/DataTable'
import DatesFilter from '@/components/shared/inputs/DatesFilter'
import StatsSmallCard from '@/components/shared/StatsSmallCard'
import UnderlinedInput from '@/components/shared/inputs/UnderlinedInput'
import ChartCard from '@/components/shared/ChartCard'
import apiService from '@/services/ApiService'
import formatter from '@/mixins/Formatter'
import { payments as dataTable } from '@/components/merchants/tables/settings'

export default {
  name: 'merchant-payment',
  components: {
    DataTable,
    DatesFilter,
    StatsSmallCard,
    ChartCard,
    UnderlinedInput
  },
  mixins: [formatter],
  mounted: function() {
    this.title = this.route.params.title || this.$t('labels.payments')
    delete this.route.params.title
  },
  data() {
    return {
      title: this.$t('labels.payments'),
      selectedRow: {},
      selectedIndex: undefined,
      selectedPayment: {},
      showRefundDialog: false,
      ...dataTable
    }
  },
  methods: {
    ...mapMutations({
      goTo: 'goTo'
    }),
    onAction: function(action, row, index, rows) {
      switch (action) {
        case 'details':
          this.goTo({ path: '/merchants/payments/' + row._id })
          break
        case 'expand':
          if (this.selectedRow._id === row._id) {
            this.selectedRow = {}
            this.selectedIndex = undefined
            rows.splice(index + 1, row.childPayments.length)
          } else {
            if (typeof this.selectedIndex !== 'undefined') {
              rows.splice(this.selectedIndex + 1, this.selectedRow.childPayments.length)
              if (this.selectedIndex < index) index = index - this.selectedRow.childPayments.length
            }
            this.selectedRow = row
            this.selectedIndex = index
            rows.splice(index + 1, 0, ...row.childPayments)
          }
          this.rows = rows
          break
        case 'refund':
          this.selectedPayment = row
          this.showRefundDialog = true
          break
        default:
          break
      }
    },
    getPayments: function(page, filters) {
      return apiService.getPayments({
        page: page - 1,
        ...filters,
        filters: JSON.stringify(filters.filters)
      })
    },
    paymentRefunded: function() {
      this.getPayments()
    },
    rowBackground: function(row) {
      if (row.TRXType !== 'payment') return '#ecfcf4'
      else if (row._id === this.selectedRow._id) return '#b9f5d7'
      else return '#ffffff'
    }
  },
  computed: {
    ...mapState({
      // arrow functions can make the code very succinct!
      displayName: state => state.user.firstName + ' ' + state.user.lastName,
      route: state => state.route
    }),
    rowActions: function() {
      const selected = this.selectedRow._id
      return [
        {
          title: 'Expand',
          name: 'expand',
          dynamicIcon: function(row) {
            return row._id === selected ? 'icon-expand' : 'icon-expanded'
          },
          showAction: function(row) {
            return row.childPayments.length > 0
          }
        },
        {
          title: 'Details',
          name: 'details',
          icon: 'icon-look',
          showAction: function(row) {
            return row.TRXType === 'payment'
          }
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/merchants/Payments.vue